/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import "stylesheets/application.css"
import "controllers"

import { Notifier } from '@airbrake/browser';
import ahoy from "ahoy.js";
// ahoy.js's ESM build (which Webpacker picks via package.json "module") READS
// window.ahoy on load but never assigns it, unlike the UMD build. Every
// client-side tracker guards on `typeof window.ahoy === "undefined"` and returns
// silently, so without this line all JS-fired events (blog scroll depth, read
// complete, CTA clicks, form starts) no-op forever while server-side
// ahoy.track in controllers keeps working. That asymmetry made it look like the
// instrumentation was fine. Assign it explicitly.
window.ahoy = ahoy;
import Turbolinks from "turbolinks";
Turbolinks.start();


// var airbrake = new airbrakeJs.Client({
//   projectId: 252310,
//   projectKey: '44d7b63436fe85298319564ace5c7268',
//   environment: 'production'
// });
// airbrake.addFilter(function(notice) {
//   notice.context.environment = "<%= Rails.env %>";
//   return notice;
// });
//
// try {
//   throw new Error('hello from airbrake-js');
// } catch (err) {
//   var promise = airbrake.notify(err);
//   promise.then(function(notice) {
//     console.log("notice id", notice.id);
//   });
// }


 const airbrake = new Notifier({
   projectId: 252310,
   projectKey: '44d7b63436fe85298319564ace5c7268',
   environment: 'production'
 });

 airbrake.addFilter((notice) => {
   notice.context.environment = process.env.RAILS_ENV;
   return notice;
 });

require("trix")
require("@rails/actiontext")